import UniLoginButton from '../components/UniLoginButton';

export default function (items) {
  items.add('logIn',
    <UniLoginButton
      className="Button Button--link"
      icon="fab arrow-right"
      path="/auth/unilogin">
      {app.translator.trans('auth-unilogin.forum.login.uni_login')}
    </UniLoginButton>
  );
}
